export const PARTNER_ORGANIZATIONS = [
  'YOMA Bank',
  'Cordaid',
  'Oikos',
  'FFI',
  'Sequa, Stenum Asia',
  'IGES',
  'UN Habitat',
  'Arche Nova',
  'WIF',
  'Water Aid',
  'Sittwe Green Network',
  'Break free from Plastic',
  'MCC',
  'RCA',
  'DUHD',
  'HBS',
  'DPUIC',
  'Union Aid',
  'Chu Chu Recycle',
  'WWF',
  'Save the children',
  'Thant Myanmar'
];

export const FUNDING_ORGANIZATIONS = [
  'German Embassy',
  'ADB',
  'World Bank',
  'HBS',
  'Japan',
  'BMZ',
  'LIFT',
  'EU Switch Asia',
  'UNDP',
  'Asian Development Bank',
  'Sida',
  'UnionAid',
  'ICRC'
];
